




















































import { Component, Vue, Watch } from "vue-property-decorator";
import UsersAPI from "@/services/users";
import User from "@/models/user";
import TableActions from "@/components/TableActions.vue";
import { LayoutModule } from "@/store/layout";
import { get } from "lodash";
import { Meta, QueryParams } from "@/models/general";
@Component({
  components: { TableActions },
})
export default class Users extends Vue {
  headers = [
    {
      text: this.$t("users.model.name"),
      sortable: false,
      value: "name",
    },
    {
      text: this.$t("users.model.family_name"),
      sortable: false,
      value: "familyName",
    },
    {
      text: this.$t("users.model.email"),
      sortable: false,
      value: "email",
    },
    {
      text: this.$t("users.model.role"),
      sortable: false,
      value: "role",
    },
    {
      text: "",
      value: "id",
    },
  ];
  users: User[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;
  searchQuery = "";

  created(): void {
    this.getUsers();
  }

  async getUsers(): Promise<void> {
    this.loading = true;

    try {
      const params: QueryParams = {
        page: {
          number: this.meta.pagination.current,
          size: this.meta.pagination.size,
        },
      };

      this.searchQuery && this.searchQuery !== ""
        ? (params.search = this.searchQuery)
        : null;

      const r = await UsersAPI.getUsers(params);
      this.users = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }

  editUser(user: User): void {
    this.$router.push({
      name: "editUser",
      params: { id: String(user.id), admin: "true" },
    });
  }

  deleteUser(id: string): void {
    LayoutModule.setDialogTitle("users.delete_user");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        await UsersAPI.deleteUser(id);
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getUsers();
  }

  @Watch("searchQuery")
  async search(): Promise<void> {
    this.getUsers();
  }
}
